import  { getSocket } from "./socket";
import { setChatList, addMessage } from "./chatSlice";

export const initChatSocket = (dispatch) => {
   const socket = getSocket()
  if (!socket) return;

  socket.emit("get_inbox");

   socket.on("connection_success", data => {
      console.log("connection_success", data);
    });


  socket.on("inbox_list", ({inbox}) => {
    dispatch(setChatList(inbox));
  });

  socket.on("chat_history", ({messages}) => {
    dispatch(addMessage(messages || []));
  });
};

export const joinRoom = (payload) => {
   const socket = getSocket()
  socket?.emit("join_conversation", payload);
  socket.emit("get_chat_history", payload);

  socket.emit('messages_read', payload);
};

export const sendMessageSocket = (payload) => {
   const socket = getSocket()
  console.log({"send_message" : payload})
  socket?.emit("send_message", payload);
};
